import Section from "./Section";
import Tabs from "./Tabs";
import { ArticleHeader } from "./Header";
import styles from "./article.module.css";

const Article = ({ header, sections, items, tabs, ...rest }) => {
  return (
    <article className={styles.article} {...rest}>
      {header ? <ArticleHeader {...header} /> : null}
      {items && <Section items={items} />}
      {tabs && <Tabs tabs={tabs} />}
      {sections ? (
        Array.isArray(sections) ? (
          sections?.map((section, idx) => (
            <div key={section?.id || idx}>
              {tabs == null || tabs?.[section?.tabId]?.active ? (
                <Section key={section?.id || idx} {...section} />
              ) : null}
            </div>
          ))
        ) : (
          <Section key={sections?.id} {...sections} />
        )
      ) : null}
    </article>
  );
};

export default Article;
